/**
 * Line item constants matching backend Constants.LineItems
 */

/**
 * Placeholder inventory item ID for draft quote line items.
 * This item has IsActive = false and is excluded from normal queries.
 * Only used in quote contexts to allow saving incomplete line items.
 */
export const PLACEHOLDER_ITEM_ID = -1;

/**
 * Default system category ID for draft/placeholder line items that don't have
 * a package or sub-item category context. This represents a generic "Item" category.
 */
export const PLACEHOLDER_SYSTEM_CATEGORY_ID = 20;
